import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface IGoogleBusinessReviewSummary {
	summary: string;
}

export function useSummarizeGoogleReviewMutation({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (value: IGoogleBusinessReviewSummary) => void;
} = {}) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			reviewId,
			impersonationContext,
		}: {
			reviewId: string;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<IGoogleBusinessReviewSummary>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `googleBusiness/review/${encodeURIComponent(reviewId)}/summarize`,
					impersonationContext,
				}),
				'POST'
			);
		},
		onError,
		onSuccess,
	});
}
